import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}

		return {
			prefs,
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},

	})
)

@providePopulateData({waitForLoad:true})
class QuestionBuilderPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onQuestionBuilderChange(value) {
		var prefsHash = { display_question_builder: value }
		this.props.onChange(prefsHash, "You successfully changed the question builder setting.");
	}

	render() {
		return (
			<div>
				<p>Control whether your students can write their own Question Builders.</p>
				<div className="viewableScoreOptions">
					<label>
						<input type="radio" onChange={ this.onQuestionBuilderChange.bind(this, true) }
							checked={ this.props.prefs.display_question_builder === true } />
						Display Question Builders on student dashboard
					</label><br />
					<label>
						<input type="radio" onChange={ this.onQuestionBuilderChange.bind(this, false) }
							checked={ this.props.prefs.display_question_builder === false } />
						Remove Question Builders from student dashboard
					</label>
				</div>
				<br></br>
				<div>
					<span> For more information on Question Builders, <a href="https://whooosreading.zendesk.com/hc/en-us/articles/8108230080013"> refer to our Help Center.</a></span>
				</div>
			</div>
		)
	}
}

QuestionBuilderPreference.WrappedComponent.propTypes = StrictPropTypes({
	// Handlers from @connect
	onChange: PropTypes.func.isRequired,
	prefs: PropTypes.object.isRequired,
	populateData: PropTypes.func.isRequired
});

module.exports = QuestionBuilderPreference; 


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/QuestionBuilderPreferences.js